import React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { useImmer } from 'use-immer';
import { CreateUserDto, IUserApiClient } from '../clients/userApiClient';
import { LoadButton } from './loadButton';
import { Alert, Grid } from '@mui/material';
import { useInjection } from '../di/ioc-provider';
import { TYPES } from '../di/types';


export interface ICreateNewAccount{
    onCancel :() => void;
}
export const CreateNewAccount = (props : ICreateNewAccount) => {
    const [t] = useTranslation("common");
    const formRef = useRef(null);
    const [saving,setLoading] = React.useState(false);
    const [success,setSuccess] = React.useState(false);
    const [error,setError] = React.useState(false);
    const [formModel,setFormModel] = useImmer<CreateUserDto>({email : "",companyName:"",vatCode : "",firstName : "",lastName : "",address : "",houseNr : "",city : "",postalCode : ""});
    
    const _userClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const createAccount = () => {
        setLoading(true);
        _userClient.createUser(formModel).takeAtLeast(1000).then((res) => {
            setSuccess(true);
            setTimeout(() => {
                props.onCancel();
            },1500)
        }).catch((err) => {
            setError(true);
        }).finally(() => {
            setLoading(false);
        })
    }
    const saveValidate = () => {
        if (formRef != null && formRef.current != null) {
            var testForm = formRef.current as any;
            testForm
                .isFormValid()
                .then((result: boolean) => {
                    if (result) {
                        createAccount();
                    }
                })
                .catch((err: any) => { });
        }
    };
   return <>
        <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
           {error ? <Alert sx={{ mt: "4px", mb: "4px" }} severity="error">{t("login.createAccountError")}</Alert> : null}
           {success ? <>
               <Alert sx={{ mt: "4px", mb: "4px" }} severity="success" >{t("login.createAccountSuccess")}</Alert>
           </> : <></>}
            <TextValidator

                disabled={saving}
                margin="normal"

                fullWidth
                label={t("general.email")}
                name="email"
               value={formModel.email}
                autoFocus
                validators={["required"]}
                errorMessages={[t("validation.required")]}
                onChange={(ev) => {
                    setFormModel((draft) => {draft.email =ev.target.value})
                }}
            />
           <TextValidator

               disabled={saving}
               margin="normal"

               fullWidth
               label={t("general.companyName")}
               name="companyName"
               value={formModel.companyName}
               autoFocus
               validators={["required"]}
               errorMessages={[t("validation.required")]}
               onChange={(ev) => {
                   setFormModel((draft) => { draft.companyName = ev.target.value })
               }}
           />
           <TextValidator

               disabled={saving}
               margin="normal"

               fullWidth
               label={t("general.custVat")}
               name="vat"
               value={formModel.vatCode}
               autoFocus
               validators={["required"]}
               errorMessages={[t("validation.required")]}
               onChange={(ev) => {
                   setFormModel((draft) => { draft.vatCode = ev.target.value })
               }}
           />
           <Grid container spacing={1}>
            <Grid item md={6}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.firstName")}
                       name="vat"
                       value={formModel.firstName}
                       autoFocus
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => { draft.firstName = ev.target.value })
                       }}
                   />
            </Grid>
               <Grid item md={6}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.lastName")}
                       name="vat"
                       value={formModel.lastName}
                       autoFocus
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => { draft.lastName = ev.target.value })
                       }}
                   />
               </Grid>
               <Grid item xs={12} md={10}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.custStreet")}
                       name="email"
                       value={formModel.address}
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => {
                               draft.address = ev.target.value;
                           })
                       }}
                   />
               </Grid>
               <Grid item xs={12} md={2}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.custHouseNr")}
                       name="email"
                       value={formModel.houseNr}
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => {
                               draft.houseNr = ev.target.value;
                           })
                       }}
                   />
               </Grid>
               <Grid item xs={12} md={6}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.custPostal")}
                       name="email"
                       value={formModel.postalCode}
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => {
                               draft.postalCode = ev.target.value;
                           })
                       }}
                   />
               </Grid>
               <Grid item xs={12} md={6}>
                   <TextValidator

                       disabled={saving}
                       margin="normal"

                       fullWidth
                       label={t("general.custCity")}
                       name="email"
                       value={formModel.city}
                       validators={["required"]}
                       errorMessages={[t("validation.required")]}
                       onChange={(ev) => {
                           setFormModel((draft) => {
                               draft.city = ev.target.value;
                           })
                       }}
                   />
               </Grid>
               </Grid>
          
            <LoadButton
                style={{ width: "100%", marginTop: "14px" }}
                isLoading={saving}
                type="submit"
                variant="contained"
                buttonText={t("general.create")}
                onClick={saveValidate}>

            </LoadButton>

        </ValidatorForm>
    </>
}